import { defineMessages } from 'react-intl';
export default defineMessages({
  livestreamStartsIn: {
    id: "CourseLivestream.livestreamStartsIn",
    defaultMessage: [{
      "type": 0,
      "value": "Livestream starts in "
    }, {
      "type": 8,
      "value": "br",
      "children": []
    }, {
      "type": 8,
      "value": "div",
      "children": [{
        "type": 1,
        "value": "days"
      }, {
        "type": 0,
        "value": " "
      }, {
        "type": 1,
        "value": "hours"
      }, {
        "type": 0,
        "value": ":"
      }, {
        "type": 1,
        "value": "minutes"
      }, {
        "type": 0,
        "value": ":"
      }, {
        "type": 1,
        "value": "seconds"
      }]
    }]
  },
  days: {
    id: "CourseLivestream.days",
    defaultMessage: [{
      "type": 1,
      "value": "days"
    }, {
      "type": 0,
      "value": " "
    }, {
      "type": 6,
      "value": "days",
      "options": {
        "one": {
          "value": [{
            "type": 0,
            "value": "day"
          }]
        },
        "other": {
          "value": [{
            "type": 0,
            "value": "days"
          }]
        }
      },
      "offset": 0,
      "pluralType": "cardinal"
    }]
  },
  livestreamChat: {
    id: "CourseLivestream.livestreamChat",
    defaultMessage: [{
      "type": 0,
      "value": "Livestream chat"
    }]
  }
});